import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Day } from '../../models/business/PolicyShift'
import { DAYS_URL } from '../../utils/urls'

const fetchDays = (params: TableParams) =>
  SBAPI.FetchPaginated<Day[]>(DAYS_URL, params)

const fetchDayById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Day>(`${DAYS_URL}/${id}`, params)

const createDay = (day: Day) => SBAPI.Post(DAYS_URL, day)

const updateDay = (day: Day) => SBAPI.Put(`${DAYS_URL}/${day.id}`, day)

const deleteDay = (day: Day) => SBAPI.Delete(`${DAYS_URL}/${day.id}`)

export { createDay, deleteDay, fetchDayById, fetchDays, updateDay }
